import { GLOBAL_VARIABLES } from '../config'
import { loadScript } from './loadScript'
import { scriptExecute } from './scriptExecute'
import { impresionEtiquetas } from '../helpers/impresionEtiquetas'
import landingConfig from '../../preproduction/js/configuracion'
import { configuracion } from '../../preproduction/js/configuracion'

export async function pixelVisitaF(retries = 5) {

    // Pixel de visita
    const idTagVisit = GLOBAL_VARIABLES.idTagVisit;

    if (retries == 5) {
        loadScript(`https://t.womtp.com/js/otg.min.js?idtag=${idTagVisit}`);
        scriptExecute();
    }

    try {
        const localHost = globalThis.location.hostname;
        let data;
        let response;

        if (localHost != "localhost") { // Para produccion
            response = await fetch(GLOBAL_VARIABLES.landingConfig);
            data = await response.json();
        } else {// Para Preproduccion
            response = configuracion;
            data = response;
        }
        // console.log({ data });
        impresionEtiquetas(data);

    } catch (error) {
        console.error("Response pixelVisita: KO", error);

        if (retries > 0) {
            await new Promise(resolve => setTimeout(resolve, 300));
            return pixelVisitaF(retries - 1);
        } else {
            console.error("Se alcanzó el límite de reintentos.");
        }
    }
}
